export const messages = {
  en: {
    listOwner: {
      title: 'Owner Management',
      searchTitle: 'Search Conditions',
      ownerInfo: 'Owner Information',
      selectRoom: 'Select Room',
      role: {
        all: 'All',
        owner: 'Owner',
        tenant: 'Tenant'
      },
      personType: {
        personal: 'Personal',
        company: 'Company'
      },
      personTypeName: 'Person Type',
      gender: {
        male: 'Male',
        female: 'Female'
      },
      columns: {
        face: 'Face',
        name: 'Name',
        type: 'Type',
        role: 'Role',
        gender: 'Gender',
        idCard: 'ID Card',
        phone: 'Phone',
        backupPhone: 'Backup Phone',
        address: 'Address',
        rooms: 'Rooms',
        members: 'Members',
        cars: 'Cars',
        debts: 'Debts',
        operation: 'Operation'
      },
      placeholders: {
        name: 'Please enter name',
        room: 'Building-Unit-Room',
        phone: 'Please enter phone',
        idCard: 'Please enter ID card'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        bindRoom: 'Bind Room',
        unbindRoom: 'Unbind Room',
        member: 'Member',
        detail: 'Detail',
        batchAutoAuth: 'Batch Auth',
        autoAuth: 'Auth'
      },
      actions: {
        editOwner: 'Edit Owner',
        deleteOwner: 'Delete Owner',
        addRoom: 'Add Room'
      },
      confirmDelete: 'Are you sure to delete?',
      messages: {
        noOwners: 'No owners in current list',
        confirmBatchAuth: 'Confirm batch authentication for {count} owners? Authenticated owners can login mini program directly.',
        authResult: 'Authentication Result',
        batchAuthResult: 'Batch authentication completed',
        authSuccess: 'Success',
        authFail: 'Failed',
        skipNoUserId: 'Skipped - Not Registered',
        skipNoRoom: 'Skipped - No Room Bound',
        confirmSingleAuth: 'Confirm authentication for owner 「{name}」? The owner can login mini program directly after authentication.',
        singleAuthSuccess: 'Authentication successful'
      }
    }
  },
  zh: {
    listOwner: {
      title: '业主管理',
      searchTitle: '查询条件',
      ownerInfo: '业主信息',
      selectRoom: '选择房屋',
      role: {
        all: '全部',
        owner: '业主',
        tenant: '租客'
      },
      personType: {
        personal: '个人',
        company: '公司'
      },
      personTypeName: '人员类型',
      gender: {
        male: '男',
        female: '女'
      },
      columns: {
        face: '人脸',
        name: '客户名称',
        type: '人员类型',
        role: '人员角色',
        gender: '性别',
        idCard: '证件号',
        phone: '联系手机',
        backupPhone: '备用手机',
        address: '地址',
        rooms: '房屋数',
        members: '业主成员',
        cars: '车辆数',
        debts: '欠费',
        operation: '操作'
      },
      placeholders: {
        name: '请输入客户名称',
        room: '楼栋-单元-房屋',
        phone: '请输入联系方式',
        idCard: '请输入业主身份证号'
      },
      buttons: {
        search: '查询',
        reset: '重置',
        add: '添加',
        save: '保存',
        cancel: '取消',
        edit: '修改',
        delete: '删除',
        bindRoom: '入住房屋',
        unbindRoom: '房屋解绑',
        member: '成员',
        detail: '详情',
        batchAutoAuth: '一键认证',
        autoAuth: '认证'
      },
      actions: {
        editOwner: '修改业主',
        deleteOwner: '删除业主',
        addRoom: '入住房屋'
      },
      confirmDelete: '确认是否删除！',
      messages: {
        noOwners: '当前列表没有业主数据',
        confirmBatchAuth: '确定对当前页 {count} 个业主进行一键认证吗？认证后业主可直接登录小程序。',
        authResult: '认证结果',
        batchAuthResult: '批量认证完成',
        authSuccess: '认证成功',
        authFail: '认证失败',
        skipNoUserId: '跳过-未注册小程序',
        skipNoRoom: '跳过-未绑定房屋',
        confirmSingleAuth: '确定对业主「{name}」进行认证吗？认证后业主可直接登录小程序。',
        singleAuthSuccess: '认证成功'
      }
    }
  }
}